import React from 'react';

import { useToast } from 'Component/Alerta';
import Btn from 'Component/Botao';
import AssistirMaisTarde from 'Interface/AssistirMaisTarde';
import {
    useAdicionarAssistirMaisTardeMutation,
    useRemoverAssistirMaisTardeMutation,
} from 'Service';

interface Props {
    className?: string;
    cursoId: number;
    dados?: AssistirMaisTarde;
    tema?: 'success'
        | 'warning'
        | 'danger'
        | 'info'
        | 'light'
        | 'dark'
        | 'darkless'
        | 'primary'
        | 'secondary'
        | 'transparent';
}

const Botao = ({ className, cursoId, dados, tema = 'light' }: Props): React.ReactElement =>
{
    const toast = useToast();
    const [ adicionarAssistirMaisTarde, { isLoading: adicionando } ] = useAdicionarAssistirMaisTardeMutation();
    const [ removerAssistirMaisTarde, { isLoading: removendo } ] = useRemoverAssistirMaisTardeMutation();

    const adicionar = async (): Promise<void> =>
    {
        try {
            await adicionarAssistirMaisTarde({ curso_id: cursoId }).unwrap();
        } catch (erro) {
            toast({
                titulo: 'Erro ao adicionar na lista',
                conteudo: 'Verifique os logs para maiores detalhes.',
                tema: 'danger',
            });
        }
    }

    const remover = async (): Promise<void> =>
    {
        if (dados) {
            try {
                await removerAssistirMaisTarde(dados).unwrap();
            } catch (erro) {
                toast({
                    titulo: 'Erro ao remover da lista',
                    conteudo: 'Verifique os logs para maiores detalhes.',
                    tema: 'danger',
                });
            }
        }
    }

    return (
        <React.Fragment>
            { dados ? (
                <Btn
                    lg
                    tema={ tema }
                    icone="check-lg"
                    className={ className }
                    processando={ removendo }
                    onClick={ remover }
                >
                    Assistir mais tarde
                </Btn>
            ) : (
                <Btn
                    lg
                    tema={ `outline-${tema as 'light'}` }
                    icone="plus-circle"
                    className={ className }
                    processando={ adicionando }
                    onClick={ adicionar }
                >
                    Assistir mais tarde
                </Btn>
            ) }
        </React.Fragment>
    );
}

export default Botao;
